import { render } from "./ViewDeliveryInfo.vue?vue&type=template&id=c1255f4e"
import script from "./ViewDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./ViewDeliveryInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__